import { push, replace } from "connected-react-router"
import { call, put, select } from "redux-saga/effects"

import { AuthSelectors } from "../Containers/LoginPage/reducer"
import { UserSelectors } from "../Containers/User/reducer"
import StartupActions from "../Redux/StartupRedux"
import API, { request } from "../Services/Api"
import { getAdminPostLoginRoute, isPublicAdminRoute } from "../Utils/adminTwoFactor"
import { isOnboardingFinished } from "../Utils/onboarding/isOnboardingFinished"
import utils, { createAccountStepPath, onboardingStepPath } from "../Utils/utils"

const registrationPages = [
  "sign-up",
  "add-email",
  "restore-password",
  "getting_started",
  "verify-code",
  "success",
  "auth",
  "mcp"
]
export const innerPagesMainApp = [
  "onboarding",
  "alerts",
  "integrations",
  "developers",
  "dashboard",
  "settings",
  "business_settings",
  "connect-shopify",
  "create-account",
  "business_accounts",
  "requests",
  "invoices",
  "referral",
  "pricing",
  "users",
  "credits",
  "configure",
  "marketing",
  "team",
  "digital-receipt",
  "health",
  "admin/2fa-verification",
  "admin/2fa-setup",
  "manual-top-up",
  "add-card",
  "getting_started",
  "manual-top-up",
  "mcp",
  "security",
  "admin_users",
  "perks",
  "payment_matching"
]

export const innerPagesPartner = ["referral"]

const authPaths = ["/auth/shopify", "/auth/stripe", "/auth/nextcommerce"]
const appType = process.env.REACT_APP_TYPE

export const defaultInnerPage = appType === "partner" ? "/referrals" : "/getting_started"
export const innerPages = appType === "partner" ? innerPagesPartner : innerPagesMainApp
const signUpPage = appType === "partner" ? "/" : "/sign-up"

// process STARTUP actions
export function* startup() {
  const userInfo = yield select(AuthSelectors.getUserInfo)
  const nextCreateAccountStep = yield select(UserSelectors.getNextCreateAccountStep)
  const accessToken = yield select(AuthSelectors.getAccessToken)
  const refreshToken = yield select(AuthSelectors.getRefreshToken)
  const { pathname, search } = document.location
  const onboardingFinished = isOnboardingFinished(userInfo)

  if (accessToken) API.updateAccessToken(accessToken, refreshToken)

  // The MCP consent page owns its own auth handling (render when signed in, bounce to login
  // when not). Don't let startup redirect the user away to their default inner page.
  if (pathname.includes("/oauth/mcp/authorize")) {
    yield put(StartupActions.startupSuccess())
    return
  }

  if (accessToken && userInfo) {
    const availablePaths = innerPages
    if (utils.includeCurrentLocation(pathname, "sign-up") && pathname !== "/sign-up") {
      //yield put(push(pathname))
    } else if (
      pathname !== "/" &&
      availablePaths.some((el) => utils.includeCurrentLocation(pathname, el))
    ) {
      const nextUrl = search?.includes("?next=") ? search?.split("?next=")?.[1] : null
      if (nextUrl) {
        let decodedNextUrl
        try {
          decodedNextUrl = decodeURIComponent(nextUrl)
        } catch (e) {
          console.error("Error decoding nextUrl:", e)
          decodedNextUrl = nextUrl // используем оригинальный URL, если декодирование не удалось
        }

        const responseOauth = yield call(request.api.post, decodedNextUrl, {
          maxRedirects: 0,
          validateStatus: (status) => status >= 200 && status < 400
        })

        if (responseOauth?.data?.redirect_uri) {
          yield put(utils.goLink(responseOauth?.data?.redirect_uri))
        } else {
          yield put(push(defaultInnerPage))
        }
      }
      // TODO: remove if we won't redirect when create new Business Account
      // if (nextCreateAccountStep && (pathname !== createAccountStepPath[nextCreateAccountStep])) {
      //   let newPath = createAccountStepPath[nextCreateAccountStep] + (search || '')
      //   yield put(push(newPath))
      // }

      // if(pathname?.includes('onboarding') && onboardingFinished){
      //   let newPath = defaultInnerPage + (search || '')
      //   yield put(replace(newPath))
      // }

      //yield put(push(search ? pathname + search : pathname))
    } else if (onboardingFinished && userInfo?.role?.name !== "Admin" && userInfo["email_added"]) {
      if (authPaths.some((path) => pathname.includes(path))) {
      } else if (nextCreateAccountStep) {
        if (pathname !== createAccountStepPath[nextCreateAccountStep])
          yield put(push(createAccountStepPath[nextCreateAccountStep] + (search || "")))
      } else {
        yield put(push(defaultInnerPage + (search || "")))
      }
    } else if (userInfo?.role?.name === "Admin") {
      if (isPublicAdminRoute(pathname)) {
        // Keep temporary 2FA pages accessible during setup.
      } else {
        yield put(push(getAdminPostLoginRoute(userInfo)))
      }
    } else if (userInfo["email_added"] && !onboardingFinished) {
      if (!userInfo["is_email_verified"]) {
        yield put(push("/getting_started" + (search || "")))
      } else if (onboardingStepPath[userInfo?.next_step]) {
        if (authPaths.some((path) => pathname.includes(path))) {
        } else {
          let newPath = onboardingStepPath[userInfo?.next_step] + (search || "")
          yield put(push(newPath))
        }
      }
    } else {
      yield put(push("/add-email"))
    }
  } else if (
    registrationPages.some((el) => utils.includeCurrentLocation(pathname, el)) ||
    signUpPage === pathname
  ) {
    if (pathname === "/sign-up") {
      yield put(push(`/sign-up${search || ""}`))
    } else if (pathname?.includes("/auth/")) {
    } else {
      //yield put(push(pathname))
    }
  } else if (isPublicAdminRoute(pathname)) {
    // Allow direct access to temporary admin 2FA pages without auth during setup.
  } else {
    if (
      !["/", "/login"]?.includes(pathname) &&
      innerPages.some((el) => utils.includeCurrentLocation(pathname, el))
    ) {
      if (pathname?.includes("/sales-tracker/stores/store/")) {
        yield put(replace("/login", { reference: "/sales-tracker/stores" }))
      } else if (pathname?.includes("/sales-tracker/products/product/")) {
        yield put(replace("/login", { reference: "/sales-tracker/products" }))
      } else {
        yield put(replace("/login", { reference: pathname + (search || "") }))
      }
    } else {
      yield put(replace(pathname === "/" ? "/login" + (search || "") : pathname + (search || "")))
    }
  }

  yield put(StartupActions.startupSuccess())
}
